import { useCallback, useContext, useState, createContext } from 'react'
import PropTypes from 'prop-types'

import { v4 as uuidv4 } from 'uuid'
import * as Sc from './snackbarFeedback.style'
import SnackBarFeedback from 'components/SnackBarFeedback'
import Portal from 'components/Portal'

const SnackBarFeedbackContext = createContext()

const SNACKBAR_TIMEOUT = 4000

export const SnackBarFeedbackProvider = ({ children }) => {
  const [snackBars, setSnackBars] = useState([])

  const addFeedback = useCallback(
    (newSnackBar) => {
      setSnackBars((snackBars) => [...snackBars, newSnackBar])
      setTimeout(
        () => setSnackBars((snackBars) => snackBars.slice(1)),
        SNACKBAR_TIMEOUT
      )
    },
    [snackBars]
  )

  return (
    <SnackBarFeedbackContext.Provider value={addFeedback}>
      {!!snackBars.length && (
        <Portal id={'snackbarFeedback'} scroll>
          <Sc.SnackBarsBox>
            {snackBars.map((snackBar) => (
              <SnackBarFeedback
                dataTestId={snackBar.dataTestId}
                id={snackBar.id}
                key={`${snackBar.id}-${uuidv4()}`}
                text={snackBar.text}
                variant={snackBar.variant}
              />
            ))}
          </Sc.SnackBarsBox>
        </Portal>
      )}
      {children}
    </SnackBarFeedbackContext.Provider>
  )
}

export default SnackBarFeedbackContext

export const useSnackBarFeedback = () => {
  return useContext(SnackBarFeedbackContext)
}

SnackBarFeedbackProvider.defaultProps = {
  children: null,
}

SnackBarFeedbackProvider.propTypes = {
  children: PropTypes.node,
}
